import React from "react";
import { Oval } from "react-loader-spinner";

interface LoaderProps {
    buttonSizePx?: number
}

const TailSpinLoader = (props: LoaderProps) => {
    return (
        <div role="status" className={'ml-1'}>
            <Oval height={props.buttonSizePx || 18}
                  width={props.buttonSizePx || 18}
                  strokeWidth={6}
                  color={"#fff"}
                  secondaryColor={"#437FB2"}
            />
        </div>
    );
}

export default TailSpinLoader;